const $ = require('jquery');
const Swiper = require('swiper/js/swiper.js');
const YouTubePlayer = require('youtube-player');

Promise; // <-- force polyfill :/

const $document = $(document);
let thumbsGallery;
let mainGallery;

function initGallery(mainSelector, thumbsSelector) {
    thumbsGallery = document.querySelector(thumbsSelector);
    mainGallery = document.querySelector(mainSelector);

    if (mainGallery === null || thumbsGallery === null) {
        return;
    }

    thumbsGallery = new Swiper(thumbsGallery, {
        init: false,
        spaceBetween: 5,
        slidesPerView: 3,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
    });

    mainGallery = new Swiper(mainGallery, {
        spaceBetween: 5,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    });

    mainGallery.on('slideChange', function() {
        thumbsGallery.slideTo(this.activeIndex - 1, thumbsGallery.params.speed, false);
    });

    thumbsGallery.on('slideChange', function() {
        mainGallery.slideTo(this.activeIndex + 1, mainGallery.params.speed, true);
    }).on('init', function() {
        $(thumbsGallery.$wrapperEl[0]).on('click', `.${thumbsGallery.params.slideClass}`, (event) => {
            for (let i = 0; i < thumbsGallery.slides.length; i++) {
                if (thumbsGallery.slides[i] === event.currentTarget) {
                    mainGallery.slideTo(i, mainGallery.params.speed, true);
                    break;
                }
            }
        });
    });

    thumbsGallery.init();
}

const ytMediaSelector = '[data-media-type="youtube-video"]';

function getYtMediaWrap(element) {
    return element.querySelector(ytMediaSelector);
}

function injectVideo(mediaWrap) {
    if (mediaWrap.player) {
        return;
    }

    const playerElement = mediaWrap.querySelector('.player');
    const videoId = playerElement.getAttribute('data-video-id');

    const player = YouTubePlayer(playerElement, {
        videoId,
        playerVars: {
            // autoplay: 0,
            iv_load_policy: 3,
            modestbranding: 1,
            rel: 0,
            showinfo: 0,
        }
    });

    player.on('stateChange', (event) => {
        if (event.data === YT.PlayerState.ENDED) {
            player.seekTo(0);
            // player.pauseVideo();
            player.stopVideo();
        }
    });

    mediaWrap.player = player;
}

function pauseVideo(mediaWrap) {
    if (!mediaWrap.player) {
        return;
    }

    mediaWrap.player.pauseVideo();
    // mediaWrap.player.seekTo(0);

    // mediaWrap.player.stopVideo();
}

function initYtVideo() {
    const firstYtWrap = getYtMediaWrap(document.querySelector('.used-car__media'));

    if (firstYtWrap === null) {
        return;
    }

    if (mainGallery) {
        let mediaWrap = getYtMediaWrap(mainGallery.slides[mainGallery.activeIndex]);

        if (mediaWrap !== null) {
            injectVideo(mediaWrap);
        }

        mainGallery.on('slideChange', function() {
            mediaWrap = getYtMediaWrap(this.slides[this.activeIndex]);

            if (mediaWrap !== null) {
                injectVideo(mediaWrap);
            }

            mediaWrap = getYtMediaWrap(this.slides[this.previousIndex]);

            if (mediaWrap !== null && mediaWrap.player) {
                pauseVideo(mediaWrap);
            }
        });
    } else {
        injectVideo(firstYtWrap);
    }
}

function initContactEmailLink(selector) {
    if (window.gtag) {
        $document.on('click', selector, (event) => {
            gtag('event', 'click email', {
                event_category: 'contatto usato',
                event_label: 'sito dealer'
            });
        });
    }
}

function init() {
    initGallery('.gallery-main', '.gallery-thumbs');

    initYtVideo();

    initContactEmailLink('.contact-email-link');
}

export { init };
